'use client';
import { createContext, useContext, useMemo, ReactNode } from 'react';
import { DEMO_USER_ID, DEMO_ACCOUNT_ID, DEMO_ACCOUNT_IDS } from '@/constants';

interface DemoUser {
  id: string;
  email: string;
  user_metadata: { full_name: string };
}

interface DemoContextType {
  isDemoMode: boolean;
  demoUser: DemoUser;
  demoAccountId: string;
  demoAccountIds: string[];
}

const DemoContext = createContext<DemoContextType | null>(null);

export function DemoProvider({ children, isDemoSubdomain }: {
  children: ReactNode;
  isDemoSubdomain: boolean;
}) {
  const value = useMemo(() => ({
    isDemoMode: isDemoSubdomain,
    demoUser: {
      id: DEMO_USER_ID,
      email: 'demo@outfame.com',
      user_metadata: { full_name: 'Demo User' },
    },
    demoAccountId: DEMO_ACCOUNT_ID,
    demoAccountIds: DEMO_ACCOUNT_IDS,
  }), [isDemoSubdomain]);

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
}

export const useDemoContext = () => useContext(DemoContext);
